import React from 'react';
import { gql } from '@yi/core';

import { graphql, PageProps } from 'gatsby';
import { MainLayout, SeriesEpisodePage as SeriesEpisodePageBody } from '~/components';

export const SeriesEpisode: React.FC<PageProps<gql.typesSsr.Query_SeriesEpisode>> = ({ data }) => {
  const { yi } = data;
  if (!yi) {
    return null;
  }
  return (
    <MainLayout pageTitle={yi.SeriesEpisode.title}>
      <SeriesEpisodePage content={yi.SeriesEpisode} />;
    </MainLayout>
  );
};

interface Props {
  content: Omit<gql.typesSsr.Query_SeriesEpisode_yi_SeriesEpisode, '__typename'>;
}

export const SeriesEpisodePage: React.FC<Props> = ({ content }) => {
  return <SeriesEpisodePageBody episode={content} />;
};

export const query = graphql`
  query Query_SeriesEpisode($id: ID!) {
    yi {
      SeriesEpisode(id: $id) {
        __typename
        id
        seasonNum
        episodeNum
        title
        cast
        hero(params: { width: 1600 }) {
          processed_url
        }
        thumbnail {
          processed_url
        }
        trailer {
          brightcove_id
        }
        description
        short_description
        media {
          brightcove_id
        }
        media_duration {
          seconds
          minutes
        }
      }
    }
  }
`;

// eslint-disable-next-line import/no-default-export
export default SeriesEpisode;
